import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { getFirmConfig } from 'src/getInitialState';
import ErrorPage from 'src/Shared/Components/ErrorPage';
import ReportsSpinner from 'src/Shared/Components/ReportingAgGrid/components/Spinner';
import CustomAppBar from './AppBar';

const Layout: React.FC<React.PropsWithChildren<{}>> = (props) => {
  const config = getFirmConfig();
  const location = useLocation();
  // pre-request the financial year for date picker
  // useGetFinancialYearQuery();
  useEffect(() => {
    document.title = 'LEAP Reports';
  }, [location]);
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <CustomAppBar />

      <div style={{ height: 'calc(100vh - 48px)', overflow: 'auto' }}>
        {!!config?.error ? (
          <ErrorPage type="Error" showButton={false} />
        ) : (
          <React.Suspense fallback={<ReportsSpinner label=""></ReportsSpinner>}>
            <Outlet></Outlet>
          </React.Suspense>
        )}
      </div>
    </div>
  );
};

export default Layout;
